import { Navigate, Outlet } from "react-router-dom";
import { select_director } from "../../stores/authSlice";
import { useSelector } from "react-redux";

const RequireDirector = () => {
    const isDirector = useSelector(select_director);

    return (
        isDirector
        ? <Outlet />
        : <Navigate to="/" replace />
    )
};

export default RequireDirector;